import { computed, ref, Ref } from 'vue';
import { IncidenciaService } from '@/services/IncidenciaService';

/** Prioridad menor que este umbral = crítica (alerta global). */
export const CRITICAL_PRIORITY_THRESHOLD = 6;

export type OpenIncidenciaResumen = {
  id: number;
  title?: string;
  priority?: number | null;
};

const openIncidenciasCount: Ref<number> = ref(0);
const openIncidencias: Ref<OpenIncidenciaResumen[]> = ref([]);
let pollingInterval: number | null = null;

function priorityValue(priority?: number | null): number {
  return IncidenciaService.getPrioridadValue(priority);
}

export function useOpenIncidencias() {
  const criticalIncidencias = computed(() =>
    openIncidencias.value.filter((item) => priorityValue(item.priority) < CRITICAL_PRIORITY_THRESHOLD)
  );

  const criticalIncidenciasCount = computed(() => criticalIncidencias.value.length);

  const hasCriticalIncidencias = computed(() => criticalIncidenciasCount.value > 0);

  const mostCriticalIncidencia = computed(() => {
    if (!criticalIncidencias.value.length) return null;
    return [...criticalIncidencias.value].sort(
      (a, b) => priorityValue(a.priority) - priorityValue(b.priority)
    )[0];
  });

  const fetchOpenIncidencias = async () => {
    try {
      const response = await IncidenciaService.getMisIncidenciasResponsable();
      openIncidencias.value = (response || []).map((item) => ({
        id: item.id,
        title: item.title,
        priority: item.priority,
      }));
      openIncidenciasCount.value = openIncidencias.value.length;
    } catch (error) {
      console.error('Error fetching open incidencias:', error);
      openIncidencias.value = [];
      openIncidenciasCount.value = 0;
    }
  };

  const startPolling = (interval = 60000) => {
    fetchOpenIncidencias();
    if (!pollingInterval) {
      pollingInterval = window.setInterval(fetchOpenIncidencias, interval);
    }
  };

  const stopPolling = () => {
    if (pollingInterval) {
      clearInterval(pollingInterval);
      pollingInterval = null;
    }
  };

  return {
    openIncidenciasCount,
    openIncidencias,
    criticalIncidencias,
    criticalIncidenciasCount,
    hasCriticalIncidencias,
    mostCriticalIncidencia,
    startPolling,
    stopPolling,
    fetchOpenIncidencias,
  };
}
